import api from './api';

export const termService = {
    async getAllTerms() {
        const response = await api.get('/term');
        return response.data;
    },

    async getCurrentTerm() {
        const response = await api.get('/term/current');
        return response.data;
    },

    async getTermByCode(code) {
        const response = await api.get(`/term/${code}`);
        return response.data;
    },

    async createTerm(termData) {
        const response = await api.post('/term', termData);
        return response.data;
    },

    async updateTerm(code, updates) {
        const response = await api.put(`/term/${code}`, updates);
        return response.data;
    },

    async deleteTerm(code) {
        const response = await api.delete(`/term/${code}`);
        return response.data;
    },

    async updateProgramWindow(code, programType, windowData) {
        const response = await api.patch(
            `/term/${code}/program-window/${programType}`,
            windowData
        );
        return response.data;
    },

    async createDeadlineExtension(code, extensionData) {
        const response = await api.post(
            `/term/${code}/deadline-extension`,
            extensionData
        );
        return response.data;
    },

    async editDeadlineExtension(code, extensionData) {
        const response = await api.put(
            `/term/${code}/deadline-extension`,
            extensionData
        );
        return response.data;
    },
};

export default termService;
